<script lang="ts">
    import { Link, NavRight, Navbar, Page, NavLeft, NavTitle } from 'framework7-svelte';
    import { _ } from 'svelte-i18n';
    
    import logo from '../assets/lisa-buko.svg';
    import InsightsGraph from './InsightsGraph.svelte';
</script>

<Page>
    <Navbar>
        <NavLeft>
            <img class="logo" src={logo} alt="logo" />
            <span>
                {$_("pages.project.ROUTE_GRAPH")}
            </span>
        </NavLeft>
        <NavTitle></NavTitle>
        <NavRight>
            <Link popupClose>
                {$_("shared.CLOSE")}
            </Link>
        </NavRight>
    </Navbar>

    <InsightsGraph/>
</Page>
